import { palette } from "./ns-color-palette";
import { NsSpacingDefault, NsTheme, NsTypographyDefault } from "./ns-eds-types";

export const dark: NsTheme = {
  name: "dark",
  colors: {
    // Content
    content: palette.gray300,
    contentEmphasis: palette.gray100,
    contentSubtle: palette.alphaWhite500,
    contentPlaceholder: palette.alphaWhite400,
    contentInverse: palette.gray800,
    contentInteractive: palette.blue400,
    contentInteractiveHover: palette.blue300,
    contentInteractivePressed: palette.blue200,
    contentInteractiveInverse: palette.blue600,
    contentSelected: palette.white,
    contentInfo: palette.blue400,
    contentSuccess: palette.green400,
    contentWarning: palette.orange400,
    contentError: palette.red300,
    contentDestructive: palette.red300,
    contentDestructiveHover: palette.red200,
    contentDestructivePressed: palette.red100,
    contentOnAccentSubtle: palette.white,
    contentOnAccentYellow: palette.gray800,
    contentLogo: palette.yellow400,

    // Background
    background: palette.gray950,
    backgroundElevated1: palette.gray900,
    backgroundElevated2: palette.gray800,
    backgroundElevated3: palette.gray700,
    backgroundSunken: palette.black,
    backgroundEmphasisPrimary: palette.blue900,
    backgroundEmphasisSecondary: palette.gray700,
    backgroundBrandPrimary: palette.gray800,
    backgroundBrandSecondary: palette.blue300,
    backgroundHover: palette.alphaWhite50,
    backgroundPressed: palette.alphaWhite100,
    backgroundSelected: palette.alphaWhite100,
    backgroundSelectedHover: palette.alphaWhite200,
    backgroundSelectedPressed: palette.alphaWhite300,
    backgroundSelectedOnBrandPrimary: palette.blue100,
    backgroundInteractive: palette.blue400,
    backgroundInteractiveHover: palette.blue300,
    backgroundInteractivePressed: palette.blue200,
    backgroundInput: palette.alphaWhite100,
    backgroundDiscovery: palette.green500,
    backgroundAlpha: palette.alphaWhite300,
    backgroundAlphaSubtle: palette.alphaWhite75,
    backgroundInverse: palette.gray200,
    backgroundOverlay: palette.alphaBlack500,
    backgroundInfoSubtle: palette.alphaWhite75,
    backgroundInfo: palette.blue400,
    backgroundInfoHover: palette.blue300,
    backgroundInfoPressed: palette.blue200,
    backgroundSuccessSubtle: palette.alphaWhite75,
    backgroundSuccess: palette.green400,
    backgroundSuccessHover: palette.green300,
    backgroundSuccessPressed: palette.green200,
    backgroundWarningSubtle: palette.alphaWhite75,
    backgroundWarning: palette.orange400,
    backgroundWarningHover: palette.orange300,
    backgroundWarningPressed: palette.orange200,
    backgroundErrorSubtle: palette.alphaWhite75,
    backgroundError: palette.red300,
    backgroundErrorHover: palette.red200,
    backgroundErrorPressed: palette.red100,
    backgroundDestructive: palette.red300,
    backgroundDestructiveHover: palette.red200,
    backgroundDestructivePressed: palette.red100,
    backgroundAccentGraySubtle: palette.alphaWhite100,
    backgroundAccentGray: palette.alphaWhite500,
    backgroundAccentBlueSubtle: palette.blue800,
    backgroundAccentBlue: palette.blue400,
    backgroundAccentGreenSubtle: palette.green800,
    backgroundAccentGreen: palette.green400,
    backgroundAccentOrangeSubtle: palette.orange800,
    backgroundAccentOrange: palette.orange400,
    backgroundAccentRedSubtle: palette.red800,
    backgroundAccentRed: palette.red400,
    backgroundAccentYellowSubtle: palette.yellow800,
    backgroundAccentYellow: palette.yellow400,
    backgroundAccentPurpleSubtle: palette.purple800,
    backgroundAccentPurple: palette.purple400,
    backgroundAccentPinkSubtle: palette.pink800,
    backgroundAccentPink: palette.pink400,

    // Border
    border: palette.alphaWhite100,
    borderSubtle: palette.alphaWhite75,
    borderEmphasis: palette.alphaWhite300,
    borderInverse: palette.alphaBlack200,
    borderInteractive: palette.blue400,
    borderInteractiveHover: palette.blue300,
    borderInteractivePressed: palette.blue200,
    borderInput: palette.transparent,
    borderInputHover: palette.transparent,
    borderInfo: palette.blue400,
    borderSuccess: palette.green400,
    borderWarning: palette.orange400,
    borderError: palette.red300,
    borderDestructive: palette.red300,
    borderDestructiveHover: palette.red200,
    borderDestructivePressed: palette.red100,
    borderLogo: palette.alphaWhite100,
    borderSelected: palette.yellow400,
    borderSelectedOnBrandPrimary: palette.yellow400,
    borderFocus: palette.blue400,
  },
  spacing: NsSpacingDefault,
  typography: NsTypographyDefault,
  boxShadow: `  box-shadow: 0px 1px 4px 0px #ffffff24;
  box-shadow: 0px 1px 2px 0px #ffffff24;`,
};
